import { render } from "./BotSettingsPage.vue?vue&type=template&id=786039d6&scoped=true"
import script from "./BotSettingsPage.vue?vue&type=script&lang=js"
export * from "./BotSettingsPage.vue?vue&type=script&lang=js"

import "./BotSettingsPage.vue?vue&type=style&index=0&id=786039d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-786039d6"]])

export default __exports__